import script from "./statements.vue?vue&type=script&setup=true&lang=js"
export * from "./statements.vue?vue&type=script&setup=true&lang=js"

import "./statements.vue?vue&type=style&index=0&id=5ad86a24&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\GhanaWaterHelpCenter\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ad86a24"]])

export default __exports__